import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";

import { SCHEDULE_SCAN_WIZARD_STEP_HEADERS } from "../constants";
import { NewScanScheduleStep } from "../types";

const NewScanScheduleStepFrequency = () => {
  return (
    <FullScreenModalBody>
      <FullScreenModalBodyHeader
        {...SCHEDULE_SCAN_WIZARD_STEP_HEADERS[NewScanScheduleStep.SetFrequency]}
      />
    </FullScreenModalBody>
  );
};

export default NewScanScheduleStepFrequency;
